import { Controller } from '@hotwired/stimulus';
import { MDCDataTable } from '@material/data-table';

export default class extends Controller {
  connect() {
    this.dataTable = new MDCDataTable(this.element);
    this.dataTable.listen('MDCDataTable:sorted', (event) => {
      this.sort(event);
    });
  }

  disconnect() {
    if (this.dataTable) {
      this.dataTable.destroy();
    }
  }

  // when a sortable column is toggled by a user, either ascendimg or descending sort
  sort(event) {
    const field = event.detail.headerCell.dataset.field;
    const direction = event.detail.sortValue;
    this.dispatch('sort', { detail: { field: field, direction: direction } });
  }
}
